import { adminServerInstance } from "../axios/instances";

import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL } from './driverTypes.js';
import { GET_BATCH_BY_PERIOD, GET_BATCH_BY_PERIOD_SUCCESS, GET_BATCH_BY_PERIOD_FAIL } from './driverTypes.js';
import { GET_ALL_CARGO_STATES, GET_ALL_CARGO_STATES_SUCCESS, GET_ALL_CARGO_STATES_FAIL } from './driverTypes.js';
import { GET_MAWB_STATISTICS, GET_MAWB_STATISTICS_SUCCESS, GET_MAWB_STATISTICS_FAIL } from './driverTypes.js';
import { UPDATE_SCANNING_STATUS, UPDATE_SCANNING_STATUS_SUCCESS, UPDATE_SCANNING_STATUS_FAIL } from './driverTypes.js';
import { SETTLE_UNSCANNED_ORDERS, SETTLE_UNSCANNED_ORDERS_SUCCESS, SETTLE_UNSCANNED_ORDERS_FAIL } from './driverTypes.js';
import { CREATE_SUB_BATCH, CREATE_SUB_BATCH_SUCCESS, CREATE_SUB_BATCH_FAIL } from './driverTypes.js';
import { GET_BLIND_SCAN_BATCH, GET_BLIND_SCAN_BATCH_SUCCESS, GET_BLIND_SCAN_BATCH_FAIL } from './driverTypes.js';
import { SET_BLIND_SCAN_BATCH, SET_BLIND_SCAN_BATCH_SUCCESS, SET_BLIND_SCAN_BATCH_FAIL } from './driverTypes.js';
import { GET_NEXT_OPERATIONS, GET_NEXT_OPERATIONS_SUCCESS, GET_NEXT_OPERATIONS_FAIL } from './driverTypes.js';
import { UPDATE_CARGO_TRACKING, UPDATE_CARGO_TRACKING_SUCCESS, UPDATE_CARGO_TRACKING_FAIL } from './driverTypes.js';
import { OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG } from './driverTypes.js';
import { UPDATE_HEAD_CELLS } from './driverTypes.js';
import { UPDATE_BATCH_COMMENTS, UPDATE_BATCH_COMMENTS_SUCCESS, UPDATE_BATCH_COMMENTS_FAIL, EDIT_CARGO_TRACKING, EDIT_CARGO_TRACKING_SUCCESS, EDIT_CARGO_TRACKING_FAIL } from './types.js';

export function updateBatchComments(batch_nos, warehouse, comments) {
    return function(dispatch) {
        dispatch({type: UPDATE_BATCH_COMMENTS})
        return adminServerInstance.post(`/batchmanager/updatebatchcomments`, {
            batch_nos: batch_nos,
            warehouse: warehouse,
            comments: comments
        })  
        .then(({data}) => {
            dispatch({
                type: UPDATE_BATCH_COMMENTS_SUCCESS,
                payload: data.data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: UPDATE_BATCH_COMMENTS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

export function getBasicInfo() {
    return function(dispatch) {
        dispatch({type: BASIC_INFO_LOAD})
        return adminServerInstance.get(`map/getbasicinfo`)  
        .then(({data}) => {
            dispatch({
                type: BASIC_INFO_LOAD_SUCCESS,
                payload: data,
            })   
            return Promise.resolve(data.data); 
        }).catch(error => {
            dispatch({
                type: BASIC_INFO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })            
    }
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function updateHeadCell(data) {
    return function(dispatch) {
        dispatch({
            type: UPDATE_HEAD_CELLS,
            payload: data,
        })
    }
}


/**
 * get batch data by time period with pagination
 * @param {*} start 
 * @param {*} end 
 */
export function getBatchDataByTimePeriod(fromTS,endTS,warehouse,mawb,page,rowsPerPage, partnerFilter) {
    return function(dispatch){
        dispatch({type: GET_BATCH_BY_PERIOD})
        return adminServerInstance.get(`/batchmanager/getbatchdatabytimeperiod?fromTS=${fromTS}&toTS=${endTS}&warehouse=${warehouse}&mawb=${mawb}&page=${page}&rowsPerPage=${rowsPerPage}&partnerFilter=${partnerFilter}`
            ).then(({data}) => {
                dispatch({
                    type: GET_BATCH_BY_PERIOD_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_BATCH_BY_PERIOD_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }    
}

/**
 * get batch data by time period with pagination
 * @param {} params 
 * @returns 
 */
// export function getBatchDataByTimePeriod(params /** page and size cann't be bypass*/) {
//     let queryCondition = "/batchmanager/getbatchdatabytimeperiod?";
//     for (let key in params) {
//         queryCondition = queryCondition + (key + "=" + params[key]) + "&";            
//     }
//     let lastIndex = queryCondition.lastIndexOf("&");
//     queryCondition = queryCondition.substring(0,lastIndex);
//     return function(dispatch) {    
//         dispatch({type: GET_BATCH_BY_PERIOD})
//         return adminServerInstance.get(queryCondition)
//         .then(({data}) => {
//             dispatch({
//                 type: GET_BATCH_BY_PERIOD_SUCCESS,
//                 payload: data.data,
//             })
//             return Promise.resolve(data.data);
//         }).catch(error => {
//             dispatch({
//                 type:  GET_BATCH_BY_PERIOD_FAIL,
//                 payload: error
//             })
//             return Promise.reject(error);
//         })
//     }
// }

/**
 * 
 */
export function getAllCargoStates() {
    return function(dispatch){
        dispatch({type: GET_ALL_CARGO_STATES})
        return adminServerInstance.get(`/batchmanager/getallcargostates`
            ).then(({data}) => {
                dispatch({
                    type: GET_ALL_CARGO_STATES_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_ALL_CARGO_STATES_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }    
}

/**
 * 
 * @param {*} mawb 
 * @returns 
 */
export function getmawbstatistics(mawb) {
    return function(dispatch){
        dispatch({type: GET_MAWB_STATISTICS})
        return adminServerInstance.get(`/batchmanager/getmawbstatistics?mawb=${mawb}`
            ).then(({data}) => {
                dispatch({
                    type: GET_MAWB_STATISTICS_SUCCESS,
                    payload: data.data.batch_data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_MAWB_STATISTICS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * update scanning status (on / off)
 * @param {*} branch 
 * @param {*} batchNo 
 * @param {*} value 
 * @returns 
 */
export function updatescanningstatus(params) {
    return function(dispatch){
        dispatch({type: UPDATE_SCANNING_STATUS})
        return adminServerInstance.post(`/batchmanager/updatescanningstatus`, params
            ).then(({data}) => {
                dispatch({
                    type: UPDATE_SCANNING_STATUS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: UPDATE_SCANNING_STATUS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * Scan finish
 * @param {*} branch 
 * @param {*} batchNos 
 * @returns 
 */
export function settleUnscannedOrders(params) {
    return function(dispatch){
        dispatch({type: SETTLE_UNSCANNED_ORDERS})
        return adminServerInstance.post(`/business/settleunscannedorders`, params
            ).then(({data}) => {
                dispatch({
                    type: SETTLE_UNSCANNED_ORDERS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: SETTLE_UNSCANNED_ORDERS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * create sub batch
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.warehouse 
 * @param {string} params.is_default // '1'
 * @param {string} params.version // '1'
 */
export function createSubBatch(params) {
    return function(dispatch){
        dispatch({type: CREATE_SUB_BATCH})
        return adminServerInstance.post(`/cargo/createsubbatch`,params
            ).then(({data}) => {
                dispatch({
                    type: CREATE_SUB_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: CREATE_SUB_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * get blind scan batch
 * @param {} warehouse 
 * @returns 
 */
export function getBlindScanBatch(warehouse) {
    return function(dispatch){
        dispatch({type: GET_BLIND_SCAN_BATCH})
        return adminServerInstance.get(`/cargo/getblindscanbatch?warehouse=${warehouse}`
            ).then(({data}) => {
                dispatch({
                    type: GET_BLIND_SCAN_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: GET_BLIND_SCAN_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * set blind scan batch
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.blind_scan_batch 
 * @param {string} params.warehouse
 * @param {string} params.off
 */
export function setBlindScanBatch(params) {    
    return function(dispatch){
        dispatch({type: SET_BLIND_SCAN_BATCH})
        return adminServerInstance.post(`/cargo/setblindbatch`, params
            ).then(({data}) => {
                dispatch({
                    type: SET_BLIND_SCAN_BATCH_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: SET_BLIND_SCAN_BATCH_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

// export function setBlindScanBatch(warehouse) {
//     return function(dispatch){
//         dispatch({type: GET_BLIND_SCAN_BATCH})
//         return adminServerInstance.get(`/cargo/getblindscanbatch?warehouse=${warehouse}`
//             ).then(({data}) => {
//                 dispatch({type: SET_BLIND_SCAN_BATCH})
//                 return adminServerInstance.post(`/cargo/setblindbatch`, {
//                     'warehouse': warehouse,
//                     'blind_scan_batch': data.data.blind_scan_batch,
//                 }
//                 ).then(({data}) => {
//                     dispatch({
//                         type: SET_BLIND_SCAN_BATCH_SUCCESS,
//                         payload: data
//                     })
//                     return Promise.resolve();
//                 }).catch(error => {
//                     dispatch({
//                         type: SET_BLIND_SCAN_BATCH_FAIL,
//                         payload: error
//                     })
//                     return Promise.reject(error);
//                 })            
//             }).catch(error => {
//                 dispatch({
//                     type: GET_BLIND_SCAN_BATCH_FAIL,
//                     payload: error
//                 })
//                 return Promise.reject(error);
//             })
//     }
// }


/**
 * 
 * @param {*} fromState 
 * @returns 
 */
export function getNextOperations(fromState) {
    return function(dispatch){
        dispatch({type: GET_NEXT_OPERATIONS})
        return adminServerInstance.get(`/batchmanager/getnextoperations?state=${fromState}`
            ).then(({data}) => {
                dispatch({
                    type: GET_NEXT_OPERATIONS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_NEXT_OPERATIONS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * Add description for batches
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.master_air_waybills 
 * @param {string} params.warehouse
 * @param {string} params.transition
 * @param {string} params.state
 * @param {Number} params.is_init // 1
 */
export function batchUpdateCargoTracking(params) {
    return function(dispatch){
        dispatch({type: UPDATE_CARGO_TRACKING})
        return adminServerInstance.post(`/cargo/batchupdatecargotracking`,params
            ).then(({data}) => {
                dispatch({
                    type: UPDATE_CARGO_TRACKING_SUCCESS,
                    payload: data.status
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: UPDATE_CARGO_TRACKING_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * Add comments for trajectory
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.boxes 
 * @param {string} params.comments
 * @param {string} params.id
 * @param {Number} params.update_time
 * @param {Number} params.warehouse
 */
export function editCargoTracking(params) {
    return function(dispatch){
        dispatch({type: EDIT_CARGO_TRACKING})
        return adminServerInstance.post(`/cargo/editcargotracking`,params
            ).then(({data}) => {
                dispatch({
                    type: EDIT_CARGO_TRACKING_SUCCESS,
                    payload: data.status
                })
                return Promise.resolve();
            }).catch(error => {
                dispatch({
                    type: EDIT_CARGO_TRACKING_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }       
}

/**
 * control the blind scan batch setting dialog
 * @param {} isOpen 
 */
 export function openBlindScanBatchSettingDialog(isOpen) {
    return function(dispatch) {
        dispatch({
            type: OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG,
            payload: isOpen,
        })
    }
}